import { MongoObservable } from 'meteor-rxjs';
import { Certificate } from '../models/certificate';

export const Certificates = new MongoObservable.Collection<Certificate>(
  'certificates',
);
